<template>
    <div>
        <div class="chooseBox" v-if="$route.name === 'id_card'">
            <span class="title">身份证选择:</span>
            <span class="detail" :class="{activeStyle:activeStatus}" @click="chooseType(true)">正面</span>
            <span class="detail" :class="{activeStyle:!activeStatus}" @click="chooseType(false)">反面</span>
        </div>
        <div class="chooseBox" v-if="$route.name === 'business_license'">
            <span class="title">营业执照板式选择:</span>
            <span class="detail" :class="{activeStyle:activeStatus}" @click="chooseType(true)">竖版</span>
            <!--            <span class="detail" :class="{activeStyle:!activeStatus}" @click="chooseType">横版</span>-->
        </div>
    </div>
</template>

<script>
    export  default {
        name:"chooseBox",
        data(){
            return{
                activeStatus:true
            }
        },
        methods:{
            chooseType(value){
                this.activeStatus = Boolean(value);
                if(this.$store.state.stepNum == 3){
                    this.$store.commit("initialStepNum");
                    this.$router.push(this.$route.path)
                }
                this.$emit("chooseType",this.activeStatus);//true 为正面，竖版  false 为反面，横版
            }
        }
    }
</script>

<style>
    .chooseBox{
        padding: 30px;
    }
    .title{
        font-weight: bold;
        font-size: 14px;
        margin-right: 30px;
    }
    .detail{
        margin-right: 20px;
        color:#8590A6;
        border: solid 1px #fff;
        padding: 3px 15px;
        cursor: pointer;
    }
    .activeStyle{
        border: solid 1px #d82a22;
        color: #d82a22;
        padding: 3px 15px;
        border-radius: 3px;
    }
</style>
